<template>
  <div class="base-setup" @click="showIconSelect = false">
    <el-form v-if="isProcess" ref="baseSetting" :model="setup" label-position="right" label-width="100px">
      <el-form-item label="审批流名称" :rules="getRule('请输入审批单名称')" prop="templateName" :error="templateNameError">
        <el-input v-model="setup.templateName" disabled size="medium" maxlength="24"  placeholder="请输入审批单名称" show-word-limit @input="setForm($event,'templateName')"></el-input>
      </el-form-item>
      <el-form-item label="审批说明">
        <el-input placeholder="请输入审批说明" v-model="setup.remark" type="textarea" show-word-limit @input="setForm($event,'remark')"
                  :autosize="{ minRows: 3, maxRows: 5}" maxlength="64"></el-input>
      </el-form-item>
      <el-form-item label="指定功能">
        <el-select v-model="functionType" disabled placeholder="请选择" size="medium" style="width: 100%;">
        <el-option :label="setup.function" value="转移">
        </el-option>
      </el-select>
      </el-form-item>
    </el-form>
    <el-form v-else ref="baseSetting" :model="setup" label-position="right" label-width="100px">
      <el-form-item label="审批单名称" :rules="getRule('请输入审批单名称')" prop="templateName" :error="templateNameError">
        <el-input v-model="setup.templateName" size="medium" maxlength="24"  placeholder="请输入审批单名称" show-word-limit @input="setForm($event,'templateName')"></el-input>
      </el-form-item>
      <el-form-item label="审批说明">
        <el-input placeholder="请输入审批说明" v-model="setup.remark" type="textarea" show-word-limit @input="setForm($event,'remark')"
                  :autosize="{ minRows: 3, maxRows: 5}" maxlength="64"></el-input>
      </el-form-item>
      <el-form-item label="审批类目" :rules="getRule('请选择审批类目')" class="group" prop="groupId" >
        <el-select v-model="setup.groupId" placeholder="请选择审批类目" size="medium" @input="setForm($event,'groupId')" style="width: 100%;">
          <el-option v-for="(op, index) in fromGroup" :key="index" :label="op.name" :value="op.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发起人范围" :rules="getRule('请选择发起人范围')" prop="whoCommit" >
        <el-select v-model="setup.whoCommit" @click.native="selectUser" @remove-tag="removeTag" value-key="name"
                   class="select-u" placeholder="请选择可以发起此表单的人员"
                   size="medium" multiple popper-class="hidden">
          <el-option v-for="(wc, index) in setup.whoCommit" :label="wc.name" :key="index" :value="wc"></el-option>
        </el-select>
      </el-form-item>


    </el-form>
    <org-picker title="发起人范围" multiple ref="orgPicker" @ok="selected"></org-picker>
  </div>
</template>

<script>
import OrgPicker from "@/components/OrgPicker";
// import {getFormGroups, updateGroup} from '@/api/design'


export default {
  name: "FormBaseSetting",
  components: {OrgPicker},
  props: {
    isProcess: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nowUserSelect: null,
      showIconSelect: false,
      select: [],
      newGroup: '',
      fromGroup: [],
      // setup: {...this.$store.state.design},
      rules:{
        templateName:'',
        groupId: [],
        whoCommit: []
      },
      templateNameError:'',
      functionType:'转移'
    }
  },
  computed: {
    setup() {
      return {...this.$store.state.design}
    }
  },
  created() {
  },
  mounted(){
    this.fetchGroups()
  },
  methods: {
    getRule(msg){
      return [{ required: true, message: msg, trigger: 'blur' }]
    },
    // 移除发起人范围
    removeTag(item){
      console.log('>>',item)
      let newSelect = this.$store.state.design.whoCommit.filter(e=>e.id!=item.id)
      this.setForm(newSelect,'whoCommit',)
    },
    // 部门分组列表
    fetchGroups() {
        this.$api.workflowGroups().then((res) => {
            if (res.code == 0) {
                let list = res.data || []
                this.fromGroup = list
            } else {
                this.$message.error(res.message)
            }
        })
    },
    addGroup() {
      // if (this.newGroup.trim() !== '') {
      //   updateGroup({name: this.newGroup.trim()}, 'post').then(rsp => {
      //     this.$message.success(rsp.data)
      //     this.getGroups()
      //   }).catch(err => this.$message.error(err.response.data))
      // }
    },
    selected(select) {
      console.log('has>>',select)
      this.setup.whoCommit = select
      this.setForm(select,'whoCommit',)
      this.$refs.baseSetting.clearValidate()
      // this.$set(this.setup, 'whoCommit', select)
      // this.setup.whoCommit = select
      //this.setup[this.nowUserSelect] = select
    },
    selectUser() {
      console.log('hi>>',this.$store.state.design.whoCommit)
      this.$refs.orgPicker.show(this.$store.state.design.whoCommit)
    },
    validate(){
      console.log('>>',this.setup)
      this.$refs.baseSetting.validate()
      let err = []
      if (!this.$isNotEmpty(this.setup.templateName)){
        err.push('审批单名称未设置')
      }
      if (!this.$isNotEmpty(this.setup.groupId)){
        err.push('审批类目未设置')
      }
      if (!this.$isNotEmpty(this.setup.whoCommit) || this.setup.whoCommit.length === 0){
        err.push('发起人范围未设置')
      }
      // if (this.setup.settings.notify.types.length === 0){
      //   err.push('审批消息通知方式未设置')
      // }
      return err
    },
    setForm(value,key){
      console.log('>>',value,key)
      this.$store.commit("updateBase",{key,value});

    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-select-dropdown {
  display: none;
}

.icon-select {
  display: flex;
  flex-wrap: wrap;
  i {
    cursor: pointer;
    font-size: large;
    padding: 10px;
    max-width: 38px !important;
    &:hover {
      box-shadow: 0 0 10px 2px #C2C2C2;
    }
  }
}

/deep/ .select-u {
  width: 100%;
}

.base-setup {
  overflow: auto;
  margin: 0 auto;
  width: 600px;
  // height: calc(100vh - 105px);
  background: #ffffff;
  margin-top: 10px;
  padding: 15px 20px;

  i:first-child {
    position: relative;
    cursor: pointer;
    font-size: xx-large;
    color: #ffffff;
    border-radius: 10px;
    padding: 10px;
  }

  .change-icon {
    margin-left: 20px;

    span {
      font-size: small;
      color: #7a7a7a;
      margin-right: 15px;
    }

    i {
      cursor: pointer;
      color: #7a7a7a;
      font-size: x-large;
    }
  }

  /deep/ {
    .el-form-item__error{
      padding-top: 0;
    }
    .el-form-item__label {
      padding: 0;
      font-weight: bold;
    }
    .el-input__inner,
    .el-textarea__inner{
      padding-left: 8px;
    }
  }

  // /deep/ .el-form-item {
    // margin-bottom: 5px;
  // }
}

/deep/ .group {
  .el-select {
    width: calc(100% - 130px);
  }

  .el-button {
    margin-left: 10px;
    width: 120px;
  }
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #EDF2F2;
}

::-webkit-scrollbar-thumb {
  border-radius: 16px;
  background-color: #e8e8e8;
}
</style>
